import { CONFIG } from 'src/app/_config/config';
import { Component, OnInit } from '@angular/core';
import { NgForm, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LoginService } from '../_services/login.service';
import { UserModel } from '../_models/user.model';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppStates } from '../_reducers/app.reducers';
import { Subscription } from 'rxjs/Subscription';

import * as actions from './../_reducers/app.actions';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  gateway: any;
  objectConections: any[];
  userFormGroup: FormGroup;
  controls: any;
  submitted = false;
  message = {
    message: null,
    class: null
  };
  urlParent: string;

  subscriptionStore: Subscription;
  datasourceList: any;

  constructor(private loginService: LoginService,
    private fb: FormBuilder,
    private router: Router,
    public spinner: NgxSpinnerService,
    private config: CONFIG,
    private store: Store<AppStates>) {
    sessionStorage.removeItem('token');
    sessionStorage.clear();
    this.subscriptionStore = this.store.select('userAppState').subscribe(statePage => {
      this.gateway = this.config.getGateway()
      this.resetState();
    });
  }

  resetState() {
    setTimeout(() => {
      this.subscriptionStore.unsubscribe();
      this.store.dispatch(actions.reset());
    }, 1);
  }

  ngOnInit() {
    this.spinner.hide();
    document.title = `Iniciar sesión`;
    sessionStorage.clear();
    
    this.loginService.getDatasource().subscribe((resp: any) => {
      this.datasourceList = resp.schemas;
      //  this.controls.datasource.setValue(this.objectConections[0].conexion);
    }, err => { console.log(err)
    });

    this.urlParent = this.gateway.urlLabvantage;

    this.userFormGroup = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', Validators.required],
      datasource: ['', Validators.required]
    });
    this.controls = this.userFormGroup.controls;
  }

  parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };

  login(user: any) {
    this.submitted = true;

    if (this.userFormGroup.invalid) {
      return;
    }
    this.message = { message: null, class: null };
    this.spinner.show();
    this.loginService.authLogin(user).subscribe((resp:any) => {
      //console.log(this.parseJwt(resp.access_token).user_name);
      let tokenUser: any[] = this.parseJwt(resp.access_token).user_name.split("###");
      console.log("RRR: ", tokenUser);
      sessionStorage.setItem('logonName', tokenUser[5]);
      sessionStorage.setItem('sysUserId', tokenUser[6]);
      sessionStorage.setItem('email', tokenUser[7]);
      this.router.navigateByUrl('/labviewer');
      sessionStorage.setItem('user', JSON.stringify(user.username));
      sessionStorage.setItem('token', JSON.stringify(resp));
      sessionStorage.setItem('database', user.datasource.name);
      sessionStorage.setItem('username', user.username);
      sessionStorage.setItem('password', btoa(user.password));

      this.store.dispatch(actions.setUserState({
        nickname: '123',
        username: user.username,
        password: user.password
      }));

    }, err => {
      /*** Tratamiento temporal mientras se resuleve problema de CORS en Login */
      /* const token  = {
        "access_token": "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiJDMTM0OTg0NDYjIyNEQ0FURUNIMjAxOSMjI0RjYXRlY2gkMjAyMCMjI0RDQVRFQ0gyMDE5IyMjTEJWSUNQIiwic2NvcGUiOlsicmVhZCIsIndyaXRlIiwidHJ1c3QiXSwiaGFzaGNvZGUiOiJd77-9yI8oeTHvv71VXHUwMDFDbe-_vUwkXFzvv70iLCJleHAiOjE2MjAxNjI1ODgsImF1dGhvcml0aWVzIjpbIlJPTEVfQURNSU4iXSwianRpIjoiMDY4MGQ2MWMtMDA1ZC00NjE1LWJlZmItZjUxNTE3NTIyMjdiIiwiY2xpZW50X2lkIjoiZGVtb2p3dC1jbGllbnQifQ.ciAxHZKw-aeB2SReC9-yBQf4A4RAwRUw1sK9GalHgSm0VboVlaHkJ77vjOf5t0lmYbrHY8YW8qmkxTnRNGu3fQ11DNT1GE7EnTTv87ZYTr4i3QD9mUMRZ44wLC0PtuU02XPkgeGZwtvatcof1m_2zKUdshYfQkBsdzdnch86VRe8K7rwitEx5AsAvJKGzMx3DpDySQNYzVPIJqVBo2CHeViKnomK8ckQ7fOUuhAPkggXJlUsFn0VmVRpyS1YuwE9_AZ0_DH7wozDM84Bhrnr4ij20SAhkiiylnmLeuV_sU4N5v3ZgfVJsPLfeKmSt7AwMk0hMxlSScJagEDCcVC6Qw",
        "token_type": "bearer",
        "refresh_token": "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiJDMTM0OTg0NDYjIyNEQ0FURUNIMjAxOSMjI0RjYXRlY2gkMjAyMCMjI0RDQVRFQ0gyMDE5IyMjTEJWSUNQIiwic2NvcGUiOlsicmVhZCIsIndyaXRlIiwidHJ1c3QiXSwiaGFzaGNvZGUiOiJd77-9yI8oeTHvv71VXHUwMDFDbe-_vUwkXFzvv70iLCJhdGkiOiJjMzBkNWY4YS02MjMzLTRjYjAtOTRkZS0xNDM2ZDY1OTU1YTMiLCJleHAiOjE2MTkwNDU0NTYsImF1dGhvcml0aWVzIjpbIlJPTEVfQURNSU4iXSwianRpIjoiNDA4MWViMWUtOTliMC00NmI2LWE0M2MtNmI0NTFiZGRjOWU1IiwiY2xpZW50X2lkIjoiZGVtb2p3dC1jbGllbnQifQ.z3gAWN97ykCKqaZWqlk24xZ9yzUg4kqvYvr7jCzySbol1d3VgcHOhYIOVy5lUIH0Pa3rH_DSgGFITE784xdsD7jnfsMA9ZbDJkMjJK_-0Bzko270yQqxmfDYrSaKsob4vzUETmeQHmQMcYMHQzhSRX4TELM3OraxrqrpEuNVqsTY9B7eIdPSRhEjdHZ4txuINEcCFTOnb6gT_KDihJimUFacbefLaflxRWXdkPW1v1qMWf6pClY3LZqtxBXq56kzLkPvKqygGN5xqxcfW0LmXmfA4H7kTYKaYf7njiT-lnou14n-YIDikZ-zLzyL6mRgJJ0yb_vmhpbSBK_iCPl5cA",
        "expires_in": 32399,
        "scope": "read write trust",
        "hashcode":"]�ȏ(y1�Um�L$\\�",
        "jti": "c30d5f8a-6233-4cb0-94de-1436d65955a3"
        };

      this.router.navigateByUrl('/web/dashboard');
      sessionStorage.setItem('user', JSON.stringify(user.username));
      sessionStorage.setItem('token', JSON.stringify(token));
      // sessionStorage.setItem('database', JSON.stringify(user.datasource));
      sessionStorage.setItem('database',JSON.stringify('LBVICP'));

      this.store.dispatch(actions.setUserState({
        nickname: '123',
        username: user.username,
        password: user.password
      }));
 *///
      this.spinner.hide();
      this.message = {
        message: err.error.message,
        class: 'alert alert-danger mt-2'
      };
    });
  }
}

